// QR path building.
//
// Separated from the component so it can be tested: the library produces a
// module matrix, and turning that matrix into an SVG path is OUR code. A
// renderer that drops or transposes modules produces a QR that looks entirely
// convincing and does not scan — and the failure would surface as an operator
// standing at a safe with a camera, which is the worst place to find it.

import qrcode from 'qrcode-generator';

export interface QrPath {
  /** A single SVG path covering every dark module, in a 0..size coordinate space. */
  d: string;
  /** Modules per side, excluding the quiet zone. */
  size: number;
}

/**
 * Error-correction level M.
 *
 * L would save four modules on a typical signing URL, which is not worth
 * halving the tolerance for glare on a screen being photographed at an angle.
 * Q and H inflate the module count enough to hurt scannability outright.
 */
export function qrPath(text: string): QrPath {
  if (!text) throw new Error('nothing to encode');
  const qr = qrcode(0, 'M');
  qr.addData(text);
  qr.make();

  const size = qr.getModuleCount();
  let d = '';
  for (let r = 0; r < size; r++) {
    for (let c = 0; c < size; c++) {
      // Column is x, row is y. Transposing here yields a mirrored code that
      // still has valid-looking finder patterns and never scans.
      if (qr.isDark(r, c)) d += `M${c},${r}h1v1h-1z`;
    }
  }
  return { d, size };
}

/** Quiet zone in modules. Scanners need it to find the code at all. */
export const QR_QUIET_ZONE = 2;
